// Shared copy for the homepage and the dedicated About / FAQ / Our Work / Reviews pages (also read by prerender.cjs).
import { FRED_HOME_FAQS } from "./seoContentV4";
import { V5_HOME_FAQS } from "./seoContentV5";

export const SAME_AS = [
  "https://www.google.com/maps/place/?q=place_id:ChIJx8Eov0VYD6wRPjfrK_i3LIE",
  "https://www.yelp.com/biz/cleanout247-san-diego",
  "https://www.facebook.com/p/CleanOut247com-61592250135113/",
  "https://www.angi.com/companylist/us/ca/nestor/cleanout-cleanoutcom-reviews-164193418.htm",
  "https://www.linkedin.com/company/cleanout247-llc/",
  "https://www.thumbtack.com/ca/san-diego/junk-removal/cleanout247-llc/service/593986489532547083",
  "https://www.homeadvisor.com/rated.CleanOut247.164193418.html",
];

export const FEATURED_AREAS = [
  { slug: "4s-ranch", name: "4S Ranch", zip: "92127" },
  { slug: "rancho-bernardo", name: "Rancho Bernardo", zip: "92128" },
  { slug: "poway", name: "Poway", zip: "92064" },
  { slug: "carmel-valley", name: "Carmel Valley", zip: "92130" },
  { slug: "rancho-penasquitos", name: "Rancho Peñasquitos", zip: "92129" },
  { slug: "scripps-ranch", name: "Scripps Ranch", zip: "92131" },
  { slug: "mira-mesa", name: "Mira Mesa", zip: "92126" },
  { slug: "escondido", name: "Escondido" },
  { slug: "san-marcos", name: "San Marcos" },
  { slug: "vista", name: "Vista" },
  { slug: "carlsbad", name: "Carlsbad" },
  { slug: "oceanside", name: "Oceanside" },
  { slug: "encinitas", name: "Encinitas" },
  { slug: "solana-beach", name: "Solana Beach" },
  { slug: "del-mar", name: "Del Mar" },
];

export const TOP_SERVICES = [
  { slug: "furniture-removal", name: "Furniture Removal" },
  { slug: "appliance-removal", name: "Appliance Removal" },
  { slug: "mattress-removal", name: "Mattress Removal" },
  { slug: "garage-cleanout", name: "Garage Cleanouts" },
  { slug: "estate-cleanout", name: "Estate Cleanouts" },
  { slug: "construction-debris-removal", name: "Construction Debris" },
  { slug: "yard-waste-removal", name: "Yard Waste Removal" },
  { slug: "commercial-junk-removal", name: "Commercial Junk Removal" },
];

export const SITE_PAGES = [
  { to: "/junk-removal-cost", label: "Prices", desc: "Every load size and item price, upfront." },
  { to: "/our-work", label: "Our Work", desc: "Before-and-after photos from real jobs." },
  { to: "/reviews", label: "Reviews", desc: "What San Diego customers say about us." },
  { to: "/about", label: "How It Works", desc: "Three simple steps, and why people pick us." },
  { to: "/services/commercial-junk-removal", label: "Commercial", desc: "Offices, property managers, HOAs, warehouses." },
  { to: "/service-areas", label: "Service Areas", desc: "North County and all of San Diego County." },
  { to: "/faq", label: "FAQ", desc: "Pricing, payment, what we take and more." },
  { to: "/blog", label: "Guides", desc: "Dump fees, disposal rules and how-tos." },
];

export const BADGES = ["Licensed & Insured", "Same-Day Service", "Serving 24/7", "Upfront Pricing", "Eco-Friendly Disposal"];

export const STEPS = [
  { n: "01", t: "Tell us what you have", d: "Call, text a photo, or use the instant quote tool. Tell us your items and where you are in San Diego County." },
  { n: "02", t: "Get an upfront price", d: "We confirm a firm, all-in price before we lift anything. No hidden fees." },
  { n: "03", t: "We haul it away", d: "We load, sweep up, and donate or recycle whatever we can." },
];

export const WHY = [
  { t: "Fast & on time", d: "Same-day and next-day pickups, seven days a week." },
  { t: "Honest pricing", d: "Posted prices and a firm quote before we start." },
  { t: "Eco-responsible", d: "We donate and recycle to keep junk out of San Diego landfills." },
  { t: "Licensed & insured", d: "Local, fully insured pros who respect your property." },
];

export const CLIENTS = [
  { t: "Property managers", d: "Unit turnovers, tenant leave-behinds and broom-ready cleanouts." },
  { t: "Homeowners & renters", d: "Single items, garages, estates and whole-house cleanouts." },
  { t: "Storage facilities", d: "Abandoned and inherited unit cleanouts." },
  { t: "Offices & businesses", d: "Office furniture, e-waste, retail and warehouse cleanouts." },
  { t: "HOAs", d: "Common-area cleanups and bulky-item removal for communities." },
];

export const BASE_HOME_FAQS = [
  { q: "How much does junk removal cost in San Diego?", a: "Pricing is based on how much space your items take up in our truck, starting around {{min}} for a small load up to about {{fullLoad}} for a full 15-cubic-yard truck. You'll always get an upfront, no-obligation price before we start — no hidden fees." },
  { q: "Do you offer same-day pickup?", a: "Yes — we offer same-day and next-day junk removal across San Diego County. Call or text (619) 999-3565 and we'll get you scheduled fast. Same-day pickup is available seven days a week." },
  { q: "What items can't you take?", a: "We can't take hazardous materials such as paint, chemicals, solvents, motor oil, asbestos or medical waste — but we'll happily point you to the right drop-off. Just about everything else is fair game." },
  { q: "Do you recycle or donate items?", a: "Yes. We sort every load and donate usable furniture and goods to local charities and recycle metal, wood, cardboard and e-waste, keeping as much as possible out of San Diego landfills." },
  { q: "Which areas of San Diego County do you serve?", a: "All of San Diego County — including 4S Ranch, Rancho Bernardo, Poway, Carmel Valley, Rancho Peñasquitos, Scripps Ranch, Mira Mesa, Escondido, San Marcos, Carlsbad, Oceanside, Encinitas, Solana Beach and Del Mar." },
  { q: "Do you accept cards, ACH, Zelle, checks & cash?", a: "Yes — we accept all major payment methods: Visa, Mastercard, American Express, PayPal, Zelle, Venmo, Cash App, Apple Pay, ACH bank transfers, checks, and cash. No deposit required — you only pay once the job is done." },
];

export const ALL_FAQS = [...BASE_HOME_FAQS, ...FRED_HOME_FAQS, ...V5_HOME_FAQS];
